import {
  FETCH_OBSERVATIONS,
  FETCH_OBSERVATIONS_SUCCESS,
  FETCH_OBSERVATIONS_FAILURE,
  OBSERVATION_SELECTED,
  OBSERVATION_DESELECTED,
  CLEAR_OBSERVATIONS
} from '../mutation-types'

const mutations = {
  [FETCH_OBSERVATIONS] (state) {
    state.loading = true
    state.error = null
  },
  [FETCH_OBSERVATIONS_SUCCESS] (state, observations) {
    state.colors = observations.colors
    state.tastes = observations.tastes
    state.odors = observations.odors
    state.states = observations.states
    const symptoms = {}
    observations.symptoms.forEach(group => {
      symptoms[group.group || 'Miscellaneous'] = group.symptoms
    })
    state.symptoms = symptoms
    state.loading = false
  },
  [FETCH_OBSERVATIONS_FAILURE] (state, error) {
    state.error = error
    state.loading = false
  },
  [OBSERVATION_SELECTED] (state, observation) {
    const { selectedObservations } = state
    state.selectedObservations = [...selectedObservations, observation]
  },
  [OBSERVATION_DESELECTED] (state, observation) {
    state.selectedObservations = state.selectedObservations.filter(obs => obs !== observation)
  },
  [CLEAR_OBSERVATIONS] (state) {
    state.selectedObservations = []
  }
}

export default mutations
